import * as exDatatable from './mount';

// ----------------------------------------------------------------------------

function init(): void {
    // Get elements (datatable)
    const elements = document.querySelectorAll<HTMLTableElement>('table[data-datatable]');
    // Foreach Elements
    for (const element of elements) {
        exDatatable.mount(element);
    }
}

// ----------------------------------------------------------------------------

// Create event (ready)
document.addEventListener('DOMContentLoaded', init);

// ----------------------------------------------------------------------------

export default init;
